

import {
 Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Collapsable from '@/components/Collapsable.vue';
import { Project, ProjectGroup } from '@/clients/omb-api';
import TableComponent from '@/components/TableComponent.vue';
import { ROLE } from '@/assets/ts/enum/role';
import getRole from '@/plugins/roleHandler';

interface TableEntry {
    deleted?: boolean;
    project: Project;
}

@Component({
    components: {
        TableComponent,
        Collapsable,
    },
})
export default class ProjectGroupDetailsProduction extends Vue {

    @Prop({ required: true })
    private projectGroup!: ProjectGroup;

    @Prop({ required: true })
    private projects!: Project[];

    private ROLE = ROLE;

    private loading = true;

    private role: ROLE = ROLE.GUEST;

    @Watch('projects', { deep: true })
    private onProjectsChanged() {
        this.$forceUpdate();
    }

    private get activeProjects(): Project[] {
        return this.filteredProjects.filter((pe) => !pe.deleted)
            .map((pe) => pe.project);
    }

    private get deletedProjects(): Project[] {
        return this.filteredProjects.filter((pe) => pe.deleted)
            .map((pe) => pe.project);
    }

    private get isAssemblyOrEAssembly(): boolean {
        return this.role === ROLE.ASSEMBLY
            || this.role === ROLE.EASSEMBLY;
    }

    private get isAtLeastPlanner(): boolean {
        return [ROLE.ADMINISTRATOR, ROLE.PLANNING, ROLE.EPLANNING].includes(this.role);
    }

    private created() {
        this.loadData();
    }

    private async loadData() {
        this.loading = true;
        this.role = await getRole();
        this.loading = false;
        this.$emit('load');
    }

    private get filteredProjects(): TableEntry[] {
        let toFilter = this.projects;
        toFilter = toFilter.filter((p) => !p.departments || (p.departments.toLowerCase()
            .includes('abteilung')));

        if (!this.isAtLeastPlanner && this.role !== ROLE.PRODUCTION) {
            toFilter = toFilter.filter((p) => p.planned);
        }

        toFilter = toFilter.filter((p) => !p.archivedAt);

        return toFilter.map((p) => ({
            deleted: false,
            project: p,
        }));
    }

    private onArchive(project: Project) {
        this.$root.$emit('updateProject', project);
    }

    private onUpdate(project: Project) {
        this.$root.$emit('updateProject', project);
    }

    private onDelete(projectId: number) {
        const toDelete = this.filteredProjects.find((p) => p.project.id === projectId);
        if (toDelete) toDelete.deleted = true;
    }

    private onRecover(project: Project) {
        const toRecover = this.filteredProjects.find((p) => p.project.id === project.id);
        if (toRecover) toRecover.deleted = false;
    }

}
